export default "__VITE_ASSET__MjH2tv$3__"